<div class="site-container">
  <app-main-header></app-main-header>
  <user-pub-banner></user-pub-banner>
  <user-pub-informations></user-pub-informations>
  <user-pub-toolbar></user-pub-toolbar>
  <app-pb-profile-stories></app-pb-profile-stories>
</div>

